export default {
  'Filter All': '全部',
  more: '查看更多',
  viewMore: '展开',
  viewLess: '收起',
}
